import { render, staticRenderFns } from "./FreshWindgetButton.vue?vue&type=template&id=29a67e38&"
import script from "./FreshWindgetButton.vue?vue&type=script&lang=js&"
export * from "./FreshWindgetButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports